import Button from 'atoms/button'
import Image from 'atoms/image';

export default function SuccessHero() {
  return (
    <>
      <div className="success-fold">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-5">
              <h1 className="text-white">Succesverhalen</h1>
              <p className="text-white">Lees de verhalen van anderen</p>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .success-fold {
            padding: 0;
            background-color: #16a8f4;
            /*background: url(/img/backgrounds/specialismen-above-fold.png);*/
            background-size: cover;
            background-repeat: no-repeat;
            background-position: bottom left;
            /*min-height: 40vh;*/
            display: flex;
            justify-content: center;
            align-items: center;
        }
  
        @media screen and (max-width: 543px) {
            .success-fold {
              min-height: unset;
            }
        }
  
        /*@media screen and (min-width: 544px) and (max-width: 767px) {
            .success-fold {
              min-height: 35vh;
            }
        }*/
      `}</style>
    </>
  )
}
